import * as types from '../actions/types';

const initialState = {
    loading: false,
    generalBalance: null,
    weeklyBalance: null,
    sportBook: null,
    cashierPayment: null,
    terminalsBalance: null,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case types.GET_REPORTS_SET_LOADING:
            return { ...state, loading: true };
        case types.SET_CASHIER_PAYMENTS_LOADING:
            return { ...state, loading: true };
        case types.GET_REPORT_GENERAL_BALANCE:
            return {
                ...state,
                loading: false,
                generalBalance: payload,
            };
        case types.RESET_REPORT_GENERAL_BALANCE: {
            return {
                ...state,
                generalBalance: [],
            };
        }
        case types.GET_REPORT_SPORT_BOOK:
            return {
                ...state,
                loading: false,
                sportBook: payload,
            };
        case types.GET_REPORT_WEEKLY_BALANCE:
            return {
                ...state,
                loading: false,
                weeklyBalance: payload,
            };
        case types.GET_REPORT_TERMINALS_BALANCE:
            return {
                ...state,
                loading: false,
                terminalsBalance: payload,
            };
        case types.SET_CASHIER_PAYMENTS:
            return {
                ...state,
                loading: false,
                cashierPayment: payload,
            };
        default:
            return state;
    }
}
